import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import DrilldownTableSS from '../../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import CustomButtonSS from '../../../../../../../Common/CustomButton/CustomButtonSS';
import './ImsReceiptsTable.css';
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import CustomTooltip from '../../../../../../../Common/Tooltip/CustomTooltip';
import { getReportsSelector } from '../../../../../../../../../redux/reducers/reducerSlices/ReportsReducerSlice';
import { showAlert } from '../../../../../../../../Assests/Utility';
import { toast } from 'react-toastify';
import axios from 'axios';

const ImsReceiptsTable = ({ data, setShowEmailModal, themeSelected, appType }) => {
    const dispatch = useDispatch();
    const { initateLoading } = useSelector(getReportsSelector);
    const [downloading, setDownloading] = useState(null);

    const tableHeaders = [
        { id: 'WarehouseName', name: 'Warehouse' },
        { id: 'Control', name: 'Control' },
        { id: 'PO', name: 'PO' },
        { id: 'App Type', name: 'AppType' },
        { id: 'CheckInTime', name: 'Check-In Time' },
        { id: 'CarrierName', name: 'Carrier' },
        { id: 'image1', name: 'Images' },
        { id: 'actions', name: 'Actions' },
    ];

    const handleViewImage = (url) => {
        if (url) {
            window.open(url, '_blank');
        }
    };

    const handleZipDownload = async (item) => {

        // The filter(Boolean) will remove any null or undefined image URLs
        const imageUrls = [item.image1, item.image2, item.image3].filter(Boolean);
        const zip = new JSZip();
        let failedDownloads = 0;

        if (imageUrls && imageUrls?.length) {
            setDownloading(item.PO);
            showAlert(toast.TYPE.INFO, `We’ve received your request to download the images. Please wait while we prepare the ZIP file — your download will begin shortly.`, 'light');


            try {
                for (let i = 0; i < imageUrls.length; i++) {
                    const imageUrl = imageUrls[i];
                    try {
                        const response = await new Promise((resolve, reject) => {
                            dispatch({
                                type: sagaActions.DOWNLOAD_TRUCK_RECEIPT_ZIP,
                                payload: { imageUrl },
                                callback: (res) => {
                                    if (res.success) {
                                        resolve(res);
                                    } else {
                                        reject(res);
                                    }
                                }
                            });
                        });
                        const blob = await (await fetch(`data:image/jpeg;base64,${response.data.imageData}`)).blob();
                        zip.file(`image${i + 1}.png`, blob);
                    } catch (error) {
                        failedDownloads++;
                    }
                }

                if (failedDownloads > 0 && failedDownloads < imageUrls.length - 1) {
                    showAlert(toast.TYPE.WARNING, `Could not download ${failedDownloads} image(s). The zip file will be created with the successfully downloaded images.`, 'light');
                }
                if (failedDownloads === 0 || failedDownloads < imageUrls.length - 1) {
                    const content = await zip.generateAsync({ type: 'blob' });
                    saveAs(content, 'images.zip');
                    showAlert(toast.TYPE.SUCCESS, 'Images have been zipped and downloaded successfully.', 'light');
                } else {
                    showAlert(toast.TYPE.ERROR, 'Failed to download images, please try again later.', 'light');
                }
            } catch (error) {
                showAlert(toast.TYPE.ERROR, 'Failed to download images.', 'light');
            } finally {
                setDownloading(null);
            }
        } else {
            showAlert(toast.TYPE.ERROR, 'No image available to download.', 'light');
        }
        setDownloading(null);
    };

    const actionsButton = (item) => {
        return (
            <div className='d-flex flex-row align-items-center justify-content-center action-button-container'>
                <CustomButtonSS
                    isLoading={false}
                    isToolTip={true}
                    dataTip={"View Receipt"}
                    dataFor={"tooltip_id_view_receipt"}
                    onClick={() => window.open(item.ReceiptURL, '_blank')}
                    className='no-border no-bg common-hover mx-2'
                    isIcon={true}
                    iconClass={`fa-solid fa-eye`}
                />
                <CustomTooltip id='tooltip_id_view_receipt' position='top' type='light' multiline={true} html={true} />
                <CustomButtonSS
                    isLoading={false}
                    isToolTip={true}
                    dataTip={"Email Receipt"}
                    dataFor={"tooltip_id_email_receipt"}
                    onClick={() => setShowEmailModal(true)}
                    className='no-border no-bg common-hover'
                    isIcon={true}
                    iconClass={`fa fa-envelope`}
                />
                <CustomTooltip id='tooltip_id_email_receipt' position='top' type='light' multiline={true} html={true} />
                {
                    appType === "TT" &&
                    <CustomButtonSS
                        isLoading={downloading === item.PO}
                        isToolTip={true}
                        dataTip={"Download All Images"}
                        dataFor={"tooltip_id_zip_images"}
                        onClick={() => handleZipDownload(item)}
                        className='no-border no-bg common-hover'
                        isIcon={true}
                        iconClass={`fa-solid fa-file-zipper`}
                    />
                }
                {
                    appType === "TT" && <CustomTooltip id='tooltip_id_zip_images' position='top' type='light' multiline={true} html={true} />

                }
            </div>
        );
    };

    const circumstancesImages = (item) => {
        const images = [item.image1, item.image2, item.image3].filter(Boolean);
        if (images.length === 0) {
            return '-';
        }
        return (
            <div className='d-flex flex-row align-items-center justify-content-center'>
                {images.map((image, index) => (
                    <img key={`circum_image_${index}`} src={image} alt={`img${index + 1}`} className='receipt-image' onClick={() => handleViewImage(image)} download />
                ))}
            </div>
        );
    };

    const formatTableData = (data) => {
        return data.map((item, index) => ({
            id: item.IDTruck,
            0: item.WarehouseName || '-',
            1: item.Control || '-',
            2: item.PO || '-',
            3: item.AppType ? item.AppType : "Turn Time",
            4: item.CheckInTime || '-',
            5: item.CarrierName || '-',
            6: circumstancesImages(item),
            7: actionsButton(item),
        }));
    };

    return (
        <DrilldownTableSS
            key={Math.random()}
            themeSelected={themeSelected}
            bodyData={data?.length ? formatTableData(data) : []}
            titleData={tableHeaders}
            showCollapse={false}
            hasCollapsableContent={false}
            showInput={false}
            showSort={false}
            arrangeOrder={null}
            arrangeKey={null}
            drillDownReport={data}
            initiateDrillDownReport={initateLoading}
            loaderArray={8}
            sortingAction={sagaActions.SORT_USER_TABLE}
            subRoot={{ pathName: 'IMReceiptsDataArr' }}
            showUTCTime={false}
            sortKey={true}
        />
    );
};

export default ImsReceiptsTable;
